export default __webpack_public_path__ + "static/media/player_6.35e8e437.jpg";